export default function initHomeVideo() {
  const player = document.querySelector('.home-video-player');
  if (!player) return;

  const video = player.querySelector('.home-video-el');
  const overlay = player.querySelector('.home-video-overlay');
  const playBtn = player.querySelector('.home-video-play');

  if (video) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.3 }
    );

    observer.observe(player);
  }

  if (playBtn) {
    playBtn.addEventListener('click', () => {
      if (video) {
        video.muted = false;
        video.controls = true;
        video.play().catch(() => {});
      }

      if (overlay) {
        overlay.classList.add('is-hidden');
      }
    });
  }
}
